import React from "react";

import WsmFitmentSchemaListPage from "../components/WsmFitmentSchemaListPage";
import { useWsmFitmentSchemas } from "../hooks/useWsmFitmentVocabulary";

export const WsmFitmentSchemaListView = () => {
  const { schemas, loading, error, retry } = useWsmFitmentSchemas();

  return (
    <WsmFitmentSchemaListPage
      schemas={loading ? undefined : schemas}
      onRetry={error ? retry : undefined}
    />
  );
};

export default WsmFitmentSchemaListView;
